module.exports = __webpack_public_path__ + "assets/83d3183f4430df4ddf51ce3fc266a118.png";